package org.zest.insan_360_website.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

@Composable
fun StatusBadge(
    text: String,
    color: Color.Rgb,
    modifier: Modifier = Modifier
) {
    Row(
        modifier
            .fontSize(0.5.cssRem)
            .flexShrink(0)
            .padding(leftRight = 0.3.cssRem, topBottom = 0.3.cssRem)
            .gap(0.3.cssRem)
            .backgroundColor(color.copyf(alpha = 0.25f))
            .borderRadius(2.cssRem),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            Modifier
                .size(0.5.cssRem)
                .borderRadius(99.px)
                .backgroundColor(color)
                .aspectRatio(1)
        )
        SpanText(
            text,
            Modifier
                .color(color)
                .fontWeight(FontWeight.Bold)
                .lineHeight(0.5.cssRem)
                .whiteSpace(WhiteSpace.NoWrap)
        )
    }
}
